/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import {
    DividerPromo,
    ButtonGroup,
    Button,
    ContentContainerBodyShift,
} from 'sarsaparilla';

export default function HowToCut() {
    return (
        <ContentContainerBodyShift className="mb-8">
            <DividerPromo
                heading="Every Kid Outdoors"
                promoHeadingLevel={2}
                backgroundImagePath={`${process.env.CDN}/img/tree_bg.jpg`}
                copy={`Fourth graders may be eligible to receive a free Christmas tree permit. Please visit this ${process.env.SITE_NAME} featured article below to learn more.`}
                contentContainerRight
                overlayImagePath={`${process.env.CDN}/img/logo-eko`}
                overlayFallbackExtension="png"
                overlayImageAlt="Every Kid Outdoors"
                isContained
                className="mb-4 how-to-cut"
            >
                <ButtonGroup isFullWidthOnMobile={false}>
                    <Button
                        appearance="tertiary-white"
                        href="/articles/location-spotlight/cut-a-tree-for-the-holidays-from-your-national-forests/120"
                        gaReportName={'How To Cut Promotion'}
                        gaReportCreative={'how to cut'}
                        gaReportPosition={'Tree Permit Splash'}
                        shouldReportToGA
                    >
                        View Featured Article
                    </Button>
                </ButtonGroup>
            </DividerPromo>
        </ContentContainerBodyShift>
    );
}
